import Chip, { type ChipProps } from '@mui/material/Chip';
import { InstallmentStatus } from '@tyro/api';
import { useTranslation } from '@tyro/i18n';

interface InstallmentsStatusChipProps
  extends Omit<ChipProps, 'color' | 'label'> {
  status: InstallmentStatus;
}

const statusColor = {
  [InstallmentStatus.Paid]: 'emerald',
  [InstallmentStatus.Failed]: 'red',
  [InstallmentStatus.Pending]: 'blue',
  [InstallmentStatus.Cancelled]: 'slate',
  [InstallmentStatus.Refunded]: 'yellow',
  [InstallmentStatus.NotStarted]: 'slate',
  [InstallmentStatus.InProgress]: 'indigo',
} as const;

export function InstallmentStatusChip({
  status,
  ...props
}: InstallmentsStatusChipProps) {
  const { t } = useTranslation(['fees']);

  return (
    <Chip
      size="small"
      variant="soft"
      color={statusColor[status]}
      label={t(`fees:installmentStatus.${status}`)}
      {...props}
    />
  );
}
